import type {FileApiModel} from '../../../api/media/file';

const YC_LOGO_SIZES = [60, 120, 180, 340] as const;

export const getYcLogoFile = (
  size: (typeof YC_LOGO_SIZES)[number],
  isTransparent?: boolean,
) => {
  const _size = YC_LOGO_SIZES.includes(size)
    ? size
    : YC_LOGO_SIZES[YC_LOGO_SIZES.length - 1];

  return {
    _id: 'file:yc-logo',
    categories: [],
    src: {
      original: {
        filename: 'YCLogo',
        mimetype: 'image/png',
        size: 0,
        url: `https://assets.yourcoach.health/${_size}x${_size}${
          isTransparent ? 't' : ''
        }.png`,
      },
    },
  } as unknown as FileApiModel;
};
